import { useEffect } from 'react'
import type { RefObject } from 'react'

/* Adds `.bb-scroll-reveal-visible` to every `.bb-scroll-reveal` descendant the first time it
   scrolls into view, then stops observing it. Falls back to revealing
   everything immediately if IntersectionObserver isn't available. */
export function useScrollReveal(containerRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const root = containerRef.current
    if (!root) return

    const targets = Array.from(root.querySelectorAll<HTMLElement>('.bb-scroll-reveal'))
    if (targets.length === 0) return

    if (typeof IntersectionObserver === 'undefined') {
      targets.forEach((el) => el.classList.add('bb-scroll-reveal-visible'))
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bb-scroll-reveal-visible')
            observer.unobserve(entry.target)
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' },
    )

    targets.forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [containerRef])
}
